import * as API from "../";

export default {
  // 考试列表
  getExamList: params => {
    return API.GET(`/clouddo-tranning/training/detail/examPageList`, params);
  },
  // 学员端培训列表
  getTrainLists: params => {
    return API.GET(`/clouddo-tranning/training/detail/pageUserList`, params);
  },
  getTrainList: params => {
    return API.GET(`/clouddo-tranning/training/detail/pageList`, params);
  },
  getTraintabel: params => {
    return API.GET(`/clouddo-tranning/training/detail/pageList`, params);
  },
  rewritePageList: params => {
    return API.GET(`/clouddo-tranning/training/detail/rewritePageList`, params);
  },
  // 培训列表开始学习
  getTrainDetailList: params => {
    return API.GET(
      `/clouddo-tranning/training/detail/getTrainingDetail`,
      params
    );
  },
  //重写获取方法
  getTrainingDetailOverwriting: params => {
    return API.GET(
      `/clouddo-tranning/training/detail/getTrainingDetailOverwriting`,
      params
    );
  },
  //获取培训记录详情接口
  getRecordingTrainingDetail: params => {
    return API.GET(
      `/clouddo-tranning/training/detail/getRecordingTrainingDetail`,
      params
    );
  },
  // 时长修改接口
  updateHour: params => {
    return API.POST(`/clouddo-tranning/training/detail/updateHour`, params);
  },
  submitPaper: params => {
    return API.POST(`/clouddo-tranning/training/detail/exam`, params);
  },
  pushTraininReminderMessage: params => {
    return API.POST(
      `/clouddo-tranning/training/detail/pushTraininReminderMessage`,
      params
    );
  },
  recordTheLength: params => {
    return API.POST(`/clouddo-tranning/training/record/app/save`, params);
  },
  //判断是否完成培训
  getLearnDetail: params => {
    return API.GET(`/clouddo-tranning/training/detail/getLearnDetail`, params);
  },
  //判断是否能播放
  getIsCanPlay: params => {
    return API.POST(
      `/clouddo-tranning/training/resources/user/account`,
      params
    );
  },
  getTask: params => {
    return API.GET(
      `/clouddo-tranning/tranning/training_program_tasks/details`,
      params
    );
  },
  bindUserTraining: params => {
    return API.POST(
      `/clouddo-tranning/t-push/bindUserTraining`,
      params
    );
  },
};



// WEBPACK FOOTER //
// ./src/api/new/student.js